<template>
    <div class="ui-navbar bg-base-100">
        <div class="flex-1">
            <a class="ui-btn ui-btn-ghost text-xl">
                <router-link to="/"
                    ><img
                        class="h-auto w-11 rounded"
                        :src="brandImg"
                        alt=""
                /></router-link>
            </a>
        </div>
        <div class="flex-none">
            <div
                v-if="isAuthenticated"
                class="ui-dropdown ui-dropdown-end"
            >
                <div
                    tabindex="0"
                    role="button"
                    class="ui-btn ui-btn-ghost ui-btn-circle ui-avatar"
                >
                    <div class="w-10 rounded-full"><settings class="h-10 w-10" /></div>
                </div>
                <ul
                    tabindex="0"
                    class="ui-menu ui-menu-sm ui-dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
                >
                    <!--                    <li>-->
                    <!--                        <a class="justify-between">-->
                    <!--                            Profile-->
                    <!--                            <span class="ui-badge">New</span>-->
                    <!--                        </a>-->
                    <!--                    </li>-->
                    <!--                    <li><a>Settings</a></li>-->
                    <li><a @click="signOut">Logout</a></li>
                </ul>
            </div>
            <ul
                v-else
                class="ui-menu ui-menu-horizontal px-1"
            >
                <li class="px-2">
                    <a
                        class="ui-btn"
                        @click="signIn"
                    >
                        <router-link to="/login">Login</router-link>
                    </a>
                </li>
                <li>
                    <a
                        class="ui-btn bg-accent"
                        @click="signUp"
                    >
                        <router-link to="/sign-up">Sign up</router-link>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { signOut } from 'firebase/auth';
import { auth } from '../system/firebase.js';
import { useContextStore } from '../store/context.js';
import brandImg from '../assets/logo.png';
import Settings from '../components/icons/settings.vue';

export default {
    name: 'NavBar',
    components: { Settings },
    computed: {
        isAuthenticated() {
            return useContextStore().isAuthenticated;
        },
        brandImg() {
            return brandImg;
        },
    },
    methods: {
        async signOut() {
            console.log('do the logout thing and redirect to the new login page');

            signOut(auth).then(() => {
                console.log('sign out successful');
                this.$router.push('/');
            });
        },
        signIn() {
            this.$router.push('/login');
        },
        signUp() {
            this.$router.push('/sign-up');
        },
    },
};
</script>
